import { normalize, schema, denormalize } from 'normalizr';

const propertyAttributeValue = new schema.Entity(
  'propertiesAttributesValues',
  {},
  { idAttribute: 'id' }
);

export function normalizeDatos(myData) {
  const mySchema = { propertiesAttributesValues: [propertyAttributeValue] };
  const normalizedData = normalize(myData, mySchema);
  return normalizedData;
}

export function normalizeDato(myData) {
  const mySchema = propertyAttributeValue;
  const normalizedData = normalize(myData, mySchema);

  return normalizedData;
}

export function denormalizeDato(myData, store) {
  const mySchema = propertyAttributeValue;

  const normalizedData = denormalize(myData, mySchema, store);

  return normalizedData;
}

export default propertyAttributeValue;
